/**
 * 进入正式规则运算前的准备工作
 * 次级优先级，权重区间90000 - 80000，步长100
 */
export default function Prepare(R){

	return [

		{
			// 格式化数据格式（有布局）
			priority: 90000,
			condition: function(R) {
		        R.when( this.lotteryType === 'ssc' && this.currentMethod.selectarea.layout );
		    },
		    consequence: function(R) {
		    	this.formatCodes = [];
		    	_.forEach(this.currentMethod.selectarea.layout, function(item, index){
		    		this.formatCodes[item.place] = _.concat(this.formatCodes[item.place] || [], this.bet.codes[index]);
		    	}.bind(this))
		        R.next();
		    }
		},
		{
			// 格式化数据格式（无布局）
			priority: 89900,
			condition: function(R) {
		        R.when( this.lotteryType === 'ssc' && !this.currentMethod.selectarea.layout );
		    },
		    consequence: function(R) {
		    	this.formatCodes = _.trim(this.bet.codes);
		        R.next();
		    }
		},
		{
			// 格式化BOX类型
			priority: 89800,
			condition: function(R) {
		        R.when( this.lotteryType === 'ssc' && this.currentMethod.selectarea.type === 'box' );
		    },
		    consequence: function(R) {
		    	this.formatCodes = [];
		    	_.forEach( this.bet.codes, function(item){
		    		this.formatCodes.push([item])
		    	}.bind(this))
		        R.next();
		    }
		},
		{
			// 保持原有格式
			priority: 80001,
			condition: function(R) {
		        R.when( this.lotteryType === 'ssc' && _.includes(this.ruleSuite, 'without-format-codes') );
		    },
		    consequence: function(R) {
		    	this.formatCodes = this.bet.codes;
		        R.next();
		    }
		}
	]

}